export type ShellNavItem = {
	label: string;
	to: string;
	/** A live count stamped beside the label. */
	badge?: "approvals";
};

export type ShellNavSection = {
	label: string;
	items: ShellNavItem[];
};

/* The core loop and its depth: everything else is a tab of an agent or a
 * section of Settings. A link stays lit on its descendants, so Agents is
 * active across every agent page. */
export const shellNav: ShellNavItem[] = [
	{ label: "Agents", to: "/agents" },
	{ label: "Conversations", to: "/conversations" },
	{ label: "Approvals", to: "/approvals", badge: "approvals" },
	{ label: "Usage", to: "/usage" },
	{ label: "Settings", to: "/settings" },
];

/* Inside Settings the sidebar itself becomes the settings nav, so the pages
 * carry no sub-nav of their own. Runtime stays lit on a sandbox class form. */
export const settingsNav: ShellNavSection[] = [
	{
		label: "Workspace",
		items: [
			{ label: "General", to: "/settings/workspace" },
			{ label: "Members", to: "/settings/members" },
		],
	},
	{
		label: "Models & runtime",
		items: [
			{ label: "Model providers", to: "/settings/providers" },
			{ label: "Runtime", to: "/settings/runtime" },
		],
	},
	{
		label: "Developers",
		items: [{ label: "API keys", to: "/settings/api-keys" }],
	},
];

/** Which nav the sidebar shows: the settings nav on any /settings page. */
export function sidebarModeFor(pathname: string): "app" | "settings" {
	return pathname === "/settings" || pathname.startsWith("/settings/") ? "settings" : "app";
}
